import { booleanAttribute, Component, computed, input, numberAttribute } from '@angular/core';

export const dividerOrientations = ['horizontal', 'vertical'] as const;
export const dividerThicknesses = ['light', 'heavy'] as const;
export type DividerOrientation = typeof dividerOrientations[number];
export type DividerThickness = typeof dividerThicknesses[number];

@Component({
  selector: 'bspk-divider',
  imports: [],
  templateUrl: './divider.component.html',
  styleUrl: './divider.component.scss',
  host: {
    role: 'separator',
    'data-bspk': 'divider',
    '[attr.aria-orientation]': 'orientation()',
    '[attr.data-orientation]': 'orientation()',
    '[attr.data-hide-padding]': 'hidePadding() || null',
    '[attr.data-thickness]': 'thickness()',
    '[style.--inset]': 'insetVar()',
  },
})
export class BspkDivider {
  /**
   * The inset (margin) of the divider.
   * The value is a number between 0 and 12, which corresponds to the spacing sizing variables defined in the theme.
   * The inset is applied to the left and right sides of the divider when the orientation is horizontal,
   * and to the top and bottom when the orientation is vertical.
   */
  readonly inset = input(0, { transform: numberAttribute });
  readonly orientation = input<DividerOrientation>('horizontal');
  readonly hidePadding = input(false, { transform: booleanAttribute });
  readonly thickness = input<DividerThickness>('light');
  readonly insetVar = computed(() => {
    const inset = this.inset();
    if (inset < 1 || inset > 12) return '0px';
    return `var(--spacing-sizing-${inset.toString().padStart(2, '0')})`;
  });
}
